import { createjs, theme } from "../../utils";
import { buildings } from "../../data/settings.json";
import manifestJson from "../../manifest.json";
const manifestData = manifestJson.data;
const requiredFields = manifestData.fields.required;
const isOffice = manifestJson.project.version.office;
// const errorFs = (err) => {
// 	// let msg = "";

// 	// switch (err.code) {
// 	// case window.FileError.QUOTA_EXCEEDED_ERR:
// 	// 	msg = "QUOTA_EXCEEDED_ERR";
// 	// 	break;
// 	// case window.FileError.NOT_FOUND_ERR:
// 	// 	msg = "NOT_FOUND_ERR";
// 	// 	break;
// 	// case window.FileError.SECURITY_ERR:
// 	// 	msg = "SECURITY_ERR";
// 	// 	break;
// 	// case window.FileError.INVALID_MODIFICATION_ERR:
// 	// 	msg = "INVALID_MODIFICATION_ERR";
// 	// 	break;
// 	// case window.FileError.INVALID_STATE_ERR:
// 	// 	msg = "INVALID_STATE_ERR";
// 	// 	break;
// 	// default:
// 	// 	msg = "Unknown Error";
// 	// 	break;
// 	// }

// 	console.error(`ERROR: ${err}`);
// };
// Note: The file system has been prefixed as of Google Chrome 12:
// window.requestFileSystem = window.requestFileSystem || window.webkitRequestFileSystem;

const lciCreator = color => {
	const lciContainer = new createjs.Container();
	const circle1Graphics = new createjs.Graphics();
	circle1Graphics.beginFill("white").drawCircle(0, 0, 36);
	const circle1Shape = new createjs.Shape(circle1Graphics);
	const circle2Graphics = new createjs.Graphics();
	circle2Graphics.beginFill("white").drawCircle(120, 0, 18);
	const circle2Shape = new createjs.Shape(circle2Graphics);
	const circle3Graphics = new createjs.Graphics();
	circle3Graphics
		.setStrokeStyle(14)
		.beginStroke(color)
		.drawCircle(190, 0, 70);
	const circle3Shape = new createjs.Shape(circle3Graphics);
	const lineGraphics = new createjs.Graphics();
	lineGraphics.beginFill("white").drawRect(0, -8, 120, 14);
	const lineShape = new createjs.Shape(lineGraphics);
	const lciText = new createjs.Text();
	lciText.set({
		text: "lci",
		font: "36px Questrial,Arial,sans,sans-serif",
		textAlign: "center",
		color,
		textBaseline: "middle",
		x: 0,
		y: 0
	});
	lciContainer.addChild(
		circle3Shape,
		circle1Shape,
		circle2Shape,
		lineShape,
		lciText
	);
	return lciContainer;
};

let state = buildings.reduce((initialState, building) => {
	const db = require(`../../data/${building}.json`);
	const colors = {};
	const dots = [];
	const floors = {};
	const lci = {};
	// db.hasFloors
	const isMultiFloor = manifestData.buildings
		.filter(b => b.name === building)
		.map(b => b.multiFloor)[0];
	const helperChooser = isMultiFloor ? "floor" : "all";

	const shapes = db.canvas.all.pois.reduce(
		(apartmentDotsShapes, poi, index) => {
			const [name] = Object.keys(poi);
			const { data } = poi[name];
			let color = !isOffice ? theme.app[`backgroundColor${data.type.replace(/\D/u, "")}`] : null;
			if (!color) {
				color = theme.app.default;
			}
			lci[name] = lciCreator(color);
			colors[name] = color;
			const textColor = theme.palette.primary.contrastText;
			dots[index] = new createjs.Graphics();
			dots[index].beginFill(color);
			dots[index].drawCircle(0, 0, 22);
			// dots[index].append(text);

			const tempContainer = new createjs.Container();

			const tempObj = new createjs.Shape(dots[index]);
			tempObj.x = -100;
			tempObj.y = -100;
			tempObj.title = name;

			const text = new createjs.Text();
			text.set({
				text: tempObj.title,
				font: `${
					tempObj.title.length <= 3 ? 20 : 12
				}px Questrial,Arial,sans,sans-serif`,
				textAlign: "center",
				color: textColor,
				textBaseline: "middle",
				x: tempObj.x,
				y: tempObj.y
			});

			tempContainer.addChild(tempObj, text);

			apartmentDotsShapes[name] = tempContainer;

			return apartmentDotsShapes;
		},
		{}
	);

	const floorsImages = Object.keys(db.canvas).reduce((floorImages, floor) => {
		if (db.canvas[floor].images.length > 0) {
			floorImages[floor] = db.canvas[floor].images.map((src, index) => {
				// const image = new Image();
				// image.crossOrigin = "anonymous";
				// image.src = `.${src}`;

				// if (index === 0) {
				// 	image.src = `.${src}`;
				// }

				// image.load = isLoad => {
				// 	if (isLoad) {
				// 		image.src = `.${src}`;
				// 	}
				// };

				return src;

				// return src.replace(".jpg", "_thumbnail.jpg");
			});

			if (floor !== "all") {
				floors[floor] = db.canvas[floor].pois.reduce((apartaments, poi) => {
					const [name] = Object.keys(poi);
					const { coordinates } = poi[name];
					const room = coordinates.reduce((apartmentPoints, coordinate) => {
						const vertices = coordinate._vertices.split(";").map(vertice => {
							const tmp = vertice.split(",");
							return [1920 * tmp[0], 1080 * tmp[1]];
						});

						apartmentPoints[coordinate._column] = new createjs.Shape();
						apartmentPoints[coordinate._column].graphics
							.beginFill(colors[name])
							.drawPolygon(0, 0, vertices);
						apartmentPoints[coordinate._column].title = name;
						apartmentPoints[coordinate._column].alpha = 0.45;

						return apartmentPoints;
					}, []);
					apartaments.push(room);
					return apartaments;
				}, []);
			}
		}

		if (floor !== "all" && db.canvas[floor].images.length < 1) {
			floors[floor] = shapes;
		}
		// This is need for canvas without floor images
		return floorImages;
	}, {});
	initialState[building] = {
		...db.canvas,
		floorsImages,
		shapes,
		dots,
		colors,
		floors,
		bg: new createjs.Shape(),
		bmp: new createjs.Bitmap(),
		framesCount: db.canvas.all.images.length,
		lights: true,
		frame: 0,
		lci,
		helperChooser,
		hasFloors: isMultiFloor,
		hoveredLot: false
	};

	return initialState;
}, {});

// const initFs = (fs) => {
// 	state = Object.keys(state).map((key) => {
// 		const building = state[key];
// 		const { floorsImages } = building;
// 		floorsImages.all.forEach((image) => {
// 			fs.root.getFile(image.src, {
// 				create: true,
// 				exclusive: true
// 			}, (file) => {
// 				console.log("\n============\n", file);
// 			});
// 		});
// 		return building;
// 	});
// };

// window.requestFileSystem(window.TEMPORARY, 1 * 1024 * 1024 * 1024, initFs, errorFs);

export default state;
